import { ComponentPropsWithoutRef } from "react";
import cn from "../util/cn";

const Spinner = ({ className }: ComponentPropsWithoutRef<"div">) => (
  <div
    className={cn(
      "inline-block size-6 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600",
      className
    )}
  />
);

export default Spinner;
